import { colorBlackTransparent600, colorBrandYamahaRed } from '@yme/tokens/colors';
import { DEFAULT_LANG } from '@yme/utils/constants';
export const EXTERNAL_WIDGET_SCRIPT = 'https://widgets.onlinesizing.bike/loader.js';
export const ONLINE_SIZING_BIKE_ID = 'oz';
export const OZ_BUTTON_SELECTOR = 'oz-eBike-button';
export const IFRAME_OZ_GENERIC_CONTAINER = 'oz-generic-container';
export const SIZE_GUIDE_BTN_DEFAULT_PROPS = {
    id: OZ_BUTTON_SELECTOR,
    'data-smart-tool': '',
    'data-fallback-locale': DEFAULT_LANG,
    'data-meta': 'oz-trigger',
    className: 'oz-trigger oz-trigger-custom',
    'data-oz-fullscreen': true,
};
export const SMARTFIT_STYLE_CONFIG = {
    primary: colorBrandYamahaRed,
    cta: colorBrandYamahaRed,
    text: '',
    background: colorBlackTransparent600,
    buttonTextColor: '',
    roundness: '0px',
    units: '',
    unitsToggle: 'true',
    frameSizeDisplay: '',
    defaultGender: '',
};
